/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierLE-react/config/PremierLE-wizard-config.json5";
import metadata from './FoodTruckPage.metadata.json5';
import styles from './FoodTruckPage.module.scss';
import ProductCoverageSelectionComponent from '../../components/FoodTruck/ProductCoverageSelection/ProductCoverageSelectionComponent';
import BusinessInformationComponent from '../../components/FoodTruck/BusinessInformation/BusinessInformationComponent';
import CyberComponent from '../../components/FoodTruck/Cyber/CyberComponent';

function FoodTruckPage(props) {

    const { wizardData: submissionVM, updateWizardData, steps, changeNextSteps } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'))
    const propertyCoverageSteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('propertyCoverages'))
    
    const {
        onValidate,
        initialValidation
    } = useValidation('FoodTruckPage');
    

    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {       
            
            const proCov = _.get(submissionVM.value, 'lobData.eveLiaLine.coverables.foodTruckCoverable.productCoverageSelection.proCovFie');
            const isProductCoverageSelected = !_.isUndefined(proCov) && proCov;

            if (isProductCoverageSelected) {
                let newSteps = steps;

                const liabilityCoveragesIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                const propertyIndex = steps.findIndex((step) => step.id === "property");

                if (propertyIndex < 0) {
                    steps.splice(liabilityCoveragesIndex + 1, 0, propertySteps[0]);
                }

                const propertyCoverageIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if (propertyCoverageIndex < 0) {
                    steps.splice(liabilityCoveragesIndex + 2, 0, propertyCoverageSteps[0]);
                }

                newSteps = steps.slice(liabilityCoveragesIndex);

                changeNextSteps(newSteps);

            } else {
                let newSteps = steps;

                const propertyIndex = steps.findIndex((step) => step.id === "property");

                if (propertyIndex >= 0) {
                    steps.splice(propertyIndex, 1);
                }

                const propertyCoverageIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if (propertyCoverageIndex >= 0) {
                    steps.splice(propertyCoverageIndex, 1);
                }

                const liabilityCoveragesIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                newSteps = steps.slice(liabilityCoveragesIndex);

                changeNextSteps(newSteps);
            }

            const {productCode} = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'FoodTruckPage', submissionVM);

            return submissionVM;

        },
        [submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
          const subVMCopy = _.clone(submissionVM);
          const productCode = _.get(subVMCopy.value, 'baseData.productCode');
          
          validationUtil.unSetIsValidationReqFlag(subVMCopy?.lobData?.eveLiaLine?.coverables?.foodTruckCoverable?.value, ' ');

          const lobLineName = productCode ? lineName[productCode] : '';
          await updateSubmission(lobLineName, 'FoodTruckPage', subVMCopy);
    
          return submissionVM;
        },
        [submissionVM]
      );

    const overrideProps = {
        productCoverageSelectionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.eveLiaLine.coverables.foodTruckCoverable.productCoverageSelection"
        },
        businessInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.eveLiaLine.coverables.foodTruckCoverable.businessInformation"
        },
        cyberComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.eveLiaLine.coverables.foodTruckCoverable.cyber"
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelectionComponent: ProductCoverageSelectionComponent,
            businessInformationComponent: BusinessInformationComponent,
            cyberComponent: CyberComponent,
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isDisableNext = () => !_.isUndefined(submissionVM.lobData) &&
        !submissionVM.lobData.eveLiaLine.coverables.foodTruckCoverable.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}                
            />
        </WizardPage>
    );
}

FoodTruckPage.propTypes = wizardProps;
export default withRouter(FoodTruckPage);
